import { Link } from "react-router-dom";

// Projects/tickets + admin menu entries (not shown in stable mode).
export const getAccountMenuItems = (user, translate, hasAssignedProjects) => {
  const items = [];

  // Projects menu (only show if not in stable mode)
  if (user) {
    const userRole = user.role || "user";
    // Only admin, sysAdmin, official see "Projects" (all projects)
    if (!["admin", "sysAdmin", "official"].includes(userRole) && hasAssignedProjects) {
      // Regular users and staff see "My Projects"
      items.push({
        key: "my-projects",
        label: <Link to="/my-projects">{translate("common.menu.myProjects", "My Projects")}</Link>,
      });
      // "My Tickets" — only if user also has a company assigned
      if (user.company_id) {
        items.push({
          key: "my-tickets",
          label: <Link to="/my-tickets">{translate("common.menu.myTickets", "My Tickets")}</Link>,
        });
      }
    }
  }

  // Admin menu (only show if not in stable mode)
  if (user && (user.role === "admin" || user.role === "sysAdmin" || user.role === "staff")) {
    const adminMenu = {
      key: "admin",
      label: <Link to="/admin">{translate("common.menu.admin", "Admin")}</Link>,
    };

    if (user.role === "sysAdmin") {
      adminMenu.children = [
        {
          key: "admin-hpc-flows",
          label: <Link to="/admin/hpc-flows">HPC Flows</Link>,
        },
        {
          key: "admin-hpc-keys",
          label: <Link to="/admin/hpc-keys">Key Management</Link>,
        },
      ];
    }

    items.push(adminMenu);
  }

  return items;
};
